/* Pagerme generic product page (v28) – any number of options */
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  class PmProduct extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-pm-variants]').textContent);
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      var start = JSON.parse(this.querySelector('[data-pm-current]').textContent || '[]');
      this.selected = start.slice();
      this.pills = Array.prototype.slice.call(this.querySelectorAll('.pm-pill[data-pm-opt]'));
      this.selects = Array.prototype.slice.call(this.querySelectorAll('select[data-pm-opt]'));
      this.idInput = this.querySelector('input.product-variant-id');
      this.priceNow = this.querySelector('[data-pm-price]');
      this.summary = this.querySelector('[data-pm-summary]');
      this.submit = this.querySelector('.product-form__submit');
      var self = this;
      this.pills.forEach(function (b) {
        b.addEventListener('click', function () { self.selected[parseInt(b.dataset.pmOpt, 10)] = b.dataset.value; self.render(); });
      });
      this.selects.forEach(function (s) {
        s.addEventListener('change', function () { self.selected[parseInt(s.dataset.pmOpt, 10)] = s.value; self.render(); });
      });
      this.querySelectorAll('.pm-thumb').forEach(function (t) { t.addEventListener('click', function () { self.showMedia(t.dataset.mediaId); }); });
      this.render(true);
    }

    current() {
      var sel = this.selected;
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] === undefined || sel[i] === o; });
      });
    }

    showMedia(id) {
      this.querySelectorAll('.pm-stage__item').forEach(function (el) { el.hidden = el.dataset.mediaId !== String(id); });
      this.querySelectorAll('.pm-thumb').forEach(function (t) { t.setAttribute('aria-current', t.dataset.mediaId === String(id) ? 'true' : 'false'); });
    }

    render(initial) {
      var sel = this.selected;
      this.pills.forEach(function (b) { b.setAttribute('aria-pressed', sel[parseInt(b.dataset.pmOpt, 10)] === b.dataset.value ? 'true' : 'false'); });
      this.selects.forEach(function (s) { s.value = sel[parseInt(s.dataset.pmOpt, 10)]; });
      var v = this.current();
      if (!v) {
        if (this.submit) { this.submit.disabled = true; this.submit.querySelector('span').textContent = this.dataset.unavailableText || 'Unavailable'; }
        return;
      }
      if (this.idInput) { this.idInput.value = v.id; this.idInput.disabled = !v.available; }
      if (this.priceNow) this.priceNow.textContent = formatMoney(v.price, this.moneyFormat);
      if (this.submit) {
        this.submit.disabled = !v.available;
        this.submit.querySelector('span').textContent = v.available ? (this.dataset.addText || 'Add to cart') : (this.dataset.soldOutText || 'Sold out');
      }
      if (this.summary && this.variants.length > 1) this.summary.textContent = v.public_title || v.title;
      if (!initial && v.featured_media && v.featured_media.id) this.showMedia(v.featured_media.id);
      if (!initial && window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      var m = String(v.option1 || '').match(/\d+/);
      var n = m ? m[0] : '1';
      document.querySelectorAll('[data-pm-n]').forEach(function (el) { el.textContent = n; });
    }
  }
  if (!customElements.get('pm-product')) customElements.define('pm-product', PmProduct);
})();
